import { CalioColors } from '@db-models/calendar-appointment.model';
import { CountryDbModel } from '@db-models/country.model';
import { CustomerDbModel } from '@db-models/customer-db.model';
import { LanguageDbModel } from '@db-models/language.model';
import { StoreDbModel } from '@db-models/store-db.model';
import { SubscriptionModel } from '@db-models/subscribe.model';
import { WorkerDbModel } from '@db-models/worker-db.model';

export interface OnboardingAppointmentDbModel {
  id: number;
  uuid: string;
  start: string;
  start_utc: string;
  end: string;
  end_utc: string;
  timezone: string;
  title: string;
  location?: string;
  worker_id: number;
  worker?: WorkerDbModel;
}

export interface ProfileCompleteData {
  is_complete: boolean;
  registration_mode: string | null;
  fields: {
    name: string | null;
    industry: string | null;
    company_size: string | null;
    phone: string | null;
    country_id: number | null;
    prename: string | null;
    lastname: string | null;
  };
}

export class PartnerDbModel {
  id: number;
  uuid: string;
  name: string;
  street: string;
  zip: number;
  city: string;
  email: string;
  phone: string;
  mobile?: string;
  facebook_url: string;
  twitter_url: string;
  google_url: string;
  commercial_register: string;
  logo: string;
  ical_hash: string;
  booking_name: string;
  currency: string;
  registration_date: string;
  micro_partner_description: string;
  url: string;
  customer_notification_preference: string;
  sms_template: string;
  email_header_template: string;
  email_body_template: string;
  timezone: string;
  appointment_booking_info: string;
  is_business: number;
  partner_notification_preference: string;
  booking_interval: number;
  sort_customers_by: string;
  sort_customers_direction: string;
  courtesy_form: string;
  hide_mobile_on_bookingsite: number;
  hide_website_on_bookingsite: number;
  hide_email_on_bookingsite: number;
  calendar_time_step: number;
  custom_identifier: number;
  country: CountryDbModel;
  bookable_via_chatbot: number;
  appointment_lead_time: number;
  event_lead_time: number;
  hide_resource_step: number;
  resource_booking_enabled: number;
  partnership_customer_number: number;
  partnership_id: number;
  language: LanguageDbModel;
  language_id: number;
  language_identifier: string;
  appointment_name_template: string;
  worker_id: number;
  contacted_by_sales: number;
  egal_wer_show: number;
  widget_background_color: string;
  country_id: number;
  show_address_on_widget: number;
  landingpage_logo: string;
  booking_page_background_logo: string;
  favicon_logo: string;
  email_logo: string;
  event_slot_booking_info: string;
  hide_back_on_bookingsite: number;
  default_cancellation_to: number;
  show_phone_on_widget: number;
  show_mobile_on_widget: number;
  show_message_on_widget: number;
  is_cart_supported: number;
  is_beta_enabled: number;
  stripe_customer_identifier: number | string;
  active_stripe_subscription: number | string;
  accept_terms_of_services: number | boolean;
  accept_privacy_policy: number;
  subscribe_calenso_newletter: number | boolean;
  single_worker_notification: number;
  is_event_reminder_enabled: number;
  is_store_branding_feature_enabled: number;
  is_appointment_reminder_enabled: number;
  event_reminder_leadtime: number;
  appointment_reminder_leadtime: number;
  allow_multiple_services_bookings: number;
  widget_header_background_color: string;
  widget_header_active_color: string;
  widget_text_color: string;
  widget_footer_background_color: string;
  widget_footer_button_color: string;
  appointment_assistant_enabled: number;
  supportWorkers?: WorkerDbModel[];
  is_super_admin: number;
  future_booking_threshold_appointments: number;
  future_booking_threshold_events: number;
  widget_expand_appointment_service_categories: number;
  lead_followup_enabled: number;
  hide_widget_cart_functionality_message: number;
  supported_widget_languages: string[];
  is_multi_language: number;
  trial_mode: string;
  trial_max: number;
  active_theme?: number;
  _translations: {
    [key: string]: PartnerMultiTranslationForm
  };
  hide_past_appointments: number;
  is_reseller: number;
  colors: CalioColors;
  subscription_type_id: number;
  subscription: SubscriptionModel;
  active_subscription: SubscriptionModel;
  gdpr_dpa_requested: number;
  enable_all_employee_button: number;
  bookingwidget_enabled: number;
  hide_mail_buttons: number;
  hide_mail_resource: number;
  hide_mail_partner_remarks: number;
  hide_mail_location: number;
  hide_mail_services: number;
  hide_mail_booking_for: number;
  hide_mail_custom_fields: number;
  hide_mail_contact_details: number;
  number_of_appointment_bookings: number;
  number_of_event_bookings: number;
  active_bexio_order_id: any;
  utm_source: any;
  tmp_password: any;
  stripe_payment_intent_id: any;
  stripe_payment_method_id: any;
  cancellation_notification_preference: number;
  has_release_notes: boolean;
  stripe_sms_subscription_item: string;
  show_salutation_in_widget: number;
  licensed_emails: number;
  licensed_employees: number;
  licensed_stores: number;
  licensed_custom_roles: number;
  licensed_events: number;
  licensed_appointment_services: number;
  licensed_webhook_endpoints: number;
  licensed_calendars_per_user: number;
  licensed_smart_widgets?: number;
  isTrialEnd: boolean;
  usedTrialDays: number;
  trialEndDate: Date;
  remainingTrialDays: number;
  customer: CustomerDbModel;
  booking_count: {
    appointments: number,
    events: number,
    total: number,
  };
  workers_without_availabilities: WorkerDbModel[];
  application_usage: string;
  company_size: string;
  industry: string;
  main_task: string;
  digitalization_suite_requested?: boolean;
  is_widget_banner_hint_enabled: number;
  widget_banner_hint_color: string;
  widget_banner_hint_text: string;
  internal_token: string;
  is_internal_widget_enabled: number;
  is_setup_done: number;
  current_setup_step: number;
  token?: string;
  booking_page_background_color: string;
  has_paid_sla: number;
  workers: WorkerDbModel[];
  spoc_worker: WorkerDbModel;
  anyone_feature_hide_ressource: number;
  is_workflow_enabled_first_time?: boolean;
  is_workflow_migration_in_progress?: boolean;
  landingpage_allow_rebooking_for_other_workers: number;
  is_appointment_reservation_enabled: number;
  is_blocked: boolean;
  is_verified_by_support: boolean;
  notifications_count: number;

  // Registration approval fields
  registration_mode?: PartnerRegistrationMode;
  approval_status?: PartnerApprovalStatus;
  is_profile_complete?: boolean;
  is_profile_complete_data?: ProfileCompleteData;
  onboarding_appointment_id?: number;
  onboarding_appointment?: OnboardingAppointmentDbModel;
  is_onboarding_call_completed?: boolean;
  // Brand signup-policy flag (sales_intro_call) surfaced on initialize_dashboard:
  // 1 = the sales onboarding call is mandatory (no skip on the almost-there screen).
  sales_intro_call_required?: number;
  approved_at?: string;
  approved_by?: number;
  approved_by_user?: { id: number; name: string };
  rejection_reason?: string;
  is_onboarding_enabled?: boolean;
  onboarding_enabled_at?: string;
  onboarding_enabled_by?: number;
  onboarding_enabled_by_user?: { id: number; name: string };
  supportStores?: StoreDbModel[];
  is_jrni_migrated: boolean;
  has_requested_resync: boolean;

  // Health scoring fields
  health_score?: number;
  health_status?: 'good' | 'average' | 'bad';
  health_updated_at?: string;
  health_breakdown?: PartnerHealthBreakdown;
  freshdesk_company_id?: number;
  freshdesk_ticket_count?: number;
  freshdesk_ticket_count_updated_at?: string;
  notification_logs_count?: number;
  addons?: PartnerAddonModel[];

  // client side properties
  landingpage_header_background_color?: string;
  booking_language?: string | null;
  landingpage_logo_redirect_url?: string;
  isFavorite?: boolean;
  is_stripe_address_update?: boolean;
  is_utc_timezone_implementation_enabled?: number;
  minimum_required_subscription_plan?: number;

  is_widget_password_protection_setting_enabled?: number;
  widget_protection_type?: string;
  otp_complexity?: string;
  otp_verification_type?: string;
}

export class SearchPartnersDbModel {
  partners: PartnerDbModel[];
  total_count: number;
}

export class PartnerTranslationForm {
  is_multi_language: boolean;
  formControl_default: PartnerMultiTranslationForm;
}

export class PartnerMultiTranslationForm {
  description: string;
  micro_partner_description?: string;
}

export interface IPartnerClientId {
  name: string;
  uuid?: string;
  client_id: string;
  login_using_email_disabled: string;
}

export interface DeletePartnerBody {
  to_expensive: boolean;
  functions: boolean;
  to_complex: boolean;
  not_interested: boolean;
  found_better_provider: boolean;
  reason: string;

  // client side properties
  is_confirmed?: boolean;
}

export const CLONE_TYPE = {
  TENANT: 'tenant',
  PARTNER: 'partner'
} as const;

export type CloneType = typeof CLONE_TYPE[keyof typeof CLONE_TYPE];

export interface PartnerCloneRequest {
  type: CloneType;
  partner_uuid: string;
  partner_basic_information: PartnerBasicInformationModel;
  information_to_export: InformationToExportModel;
}

interface PartnerBasicInformationModel {
  email: string;
  first_name?: string;
  last_name?: string;
  phone_number: string;
  company_size: string;
  company_name: string;
  industry: string;
}

interface InformationToExportModel {
  custom_css: boolean;
  appointment_service: boolean;
  booking_questions: boolean;
  booking_question_options: boolean;
  workflow: boolean;
  partner_settings: boolean;
  vat: boolean;
  customer_types: boolean;
  booking_types: boolean;
  attributes: boolean;
}

export interface PartnerAddonModel {
  uuid: string;
  name: string;
}

export type PartnerHealthStatus = 'good' | 'average' | 'bad';

export interface PartnerHealthMetric {
  points: number;
  max_points: number;
  threshold: number;
  value: number;
  source?: string;
  excluded?: boolean;
}

export interface PartnerHealthBreakdown {
  total_score: number;
  status: PartnerHealthStatus;
  scaled: boolean;
  last_booking: PartnerHealthMetric & { days_since: number; booking_type?: 'appointment' | 'event' | null };
  dashboard_login: PartnerHealthMetric & { days_since: number };
  support_tickets: PartnerHealthMetric & { ticket_count: number; source?: 'zendesk' | 'freshdesk' | null; excluded?: boolean };
  calculated_at?: string;
}

export type PartnerApprovalStatus = 'pending_approval' | 'approved' | 'blocked';
export type PartnerRegistrationMode = 'PLG' | 'SLG';

export const PARTNER_REGISTRATION_MODE = {
  PLG: 'PLG' as PartnerRegistrationMode,
  SLG: 'SLG' as PartnerRegistrationMode
} as const;

export interface PartnerListParams {
  limit: number;
  offset: number;
  query?: string;
  healthStatus?: PartnerHealthStatus;
  subscriptionType?: string;
  approvalStatus?: PartnerApprovalStatus;
  favoriteUuids?: string[];
}
